import { Link } from "react-router-dom";
const About = () => {
    return (
        <about>
            <section class="inner-banner">
        <div class="banner-curve"></div>
		<div class="auto-container">
            <div class="inner">
                <div class="theme-icon"></div>
    			<div class="title-box">
                    <h1>About Us</h1>
                    <div class="d-text">Building a relationship between IT Services</div>
                </div>
            </div>
		</div>
    </section>
            <section className="about-section-three">
                <div className="auto-container">
                    <div className="sec-title centered">
                        <div className="upper-text">AlphaBlind – Web & IT Solutions</div>
                        <h2><strong>Your Trusted Web & Mobile Development Partner</strong></h2>
                    </div>

                    <div className="upper-row">
                        <div className="row clearfix">

                            {/* Text Column */}
                            <div className="text-column col-lg-6 col-md-12 col-sm-12">
                                <div className="inner">
                                    <div className="text">
                                        <p>
                                            At AlphaBlind, we empower businesses with modern, high-performance 
                                            digital solutions. From websites to mobile applications, we design 
                                            and develop platforms that help brands grow, stand out, and succeed 
                                            in today’s competitive digital world.
                                        </p>

                                        <p>
                                            Our expertise covers full-stack development, UI/UX, mobile apps, 
                                            SEO, cloud integration, and custom IT solutions—ensuring your 
                                            business gets the technology it truly deserves.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Bullet Column */}
                            <div className="text-column col-lg-6 col-md-12 col-sm-12">
                                <div className="inner">
                                    <div className="text">
                                        <ul className="list-style-one">
                                            <li>Professional Web Design & Web Development</li>
                                            <li>Android & iOS Mobile Application Development</li>
                                            <li>SEO & Digital Growth Services for Businesses</li>
                                            <li>End-to-End Solutions for Startups & Enterprises</li>
                                            <li>Experienced Team Focused on Quality & Innovation</li>
                                            <li>Long-term Support, Maintenance & Improvements</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                   {/* LOWER ROW – ALL SERVICES STATIC */}
<div className="lower-row">
    <div className="row clearfix">

        {/* Web Design & Development */}
        <div className="featured-block col-lg-4 col-md-6 col-sm-12">
            <div className="inner-box wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                <div className="image-box">
                    <Link to="/services">
                        <img src="assets/images/images/web1.png" alt="Web Design & Development" />
                    </Link>
                </div>
                <div className="lower-box">
                    <h3><Link to="/services">Web Design & Development</Link></h3>
                    <div className="text">
                        Modern, responsive, and high-performance websites tailored to your business goals.
                    </div>
                    <div className="more-link"><Link to="/services"><span className="fa fa-arrow-right"></span></Link></div>
                </div>
            </div>
        </div>

        {/* Android App Development */}
        <div className="featured-block col-lg-4 col-md-6 col-sm-12">
            <div className="inner-box wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
                <div className="image-box">
                    <Link to="/services">
                        <img src="assets/images/images/android.png" alt="Android Development" />
                    </Link>
                </div>
                <div className="lower-box">
                    <h3><Link to="/services">Android App Development</Link></h3>
                    <div className="text">
                        Scalable and feature-rich Android applications built for performance and reliability.
                    </div>
                    <div className="more-link"><Link to="/services"><span className="fa fa-arrow-right"></span></Link></div>
                </div>
            </div>
        </div>

        {/* iOS App Development */}
        <div className="featured-block col-lg-4 col-md-6 col-sm-12">
            <div className="inner-box wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
                <div className="image-box">
                    <Link to="/services">
                        <img src="assets/images/images/ios1.png" alt="iOS Development" />
                    </Link>
                </div>
                <div className="lower-box">
                    <h3><Link to="/services">iOS App Development</Link></h3>
                    <div className="text">
                        Robust, secure, and elegant iOS applications crafted for seamless user experience.
                    </div>
                    <div className="more-link"><Link to="/services"><span className="fa fa-arrow-right"></span></Link></div>
                </div>
            </div>
        </div>

        {/* SEO Optimization */}
        <div className="featured-block col-lg-4 col-md-6 col-sm-12">
            <div className="inner-box wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                <div className="image-box">
                    <Link to="/services">
                        <img src="assets/images/images/seo.png" alt="SEO Optimization" />
                    </Link>
                </div>
                <div className="lower-box">
                    <h3><Link to="/services">SEO Optimization</Link></h3>
                    <div className="text">
                        Improve visibility, rank higher on search engines, and attract quality traffic.
                    </div>
                    <div className="more-link"><Link to="/services"><span className="fa fa-arrow-right"></span></Link></div>
                </div>
            </div>
        </div>

        {/* UI/UX Design */}
        <div className="featured-block col-lg-4 col-md-6 col-sm-12">
            <div className="inner-box wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
                <div className="image-box">
                    <Link to="/services">
                        <img src="assets/images/images/uiux.png" alt="UI/UX Design" />
                    </Link>
                </div>
                <div className="lower-box">
                    <h3><Link to="/services">UI / UX Design</Link></h3>
                    <div className="text">
                        Clean, intuitive, and user-centric designs that enhance digital experience.
                    </div>
                    <div className="more-link"><Link to="/services"><span className="fa fa-arrow-right"></span></Link></div>
                </div>
            </div>
        </div>

        {/* E-Commerce Development */}
        <div className="featured-block col-lg-4 col-md-6 col-sm-12">
            <div className="inner-box wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
                <div className="image-box">
                    <Link to="/services">
                        <img src="assets/images/images/ecom1.png" alt="E-Commerce Development" />
                    </Link>
                </div>
                <div className="lower-box">
                    <h3><Link to="/services">E-Commerce Development</Link></h3>
                    <div className="text">
                        High-conversion online stores designed for performance and growth.
                    </div>
                    <div className="more-link"><Link to="/services"><span className="fa fa-arrow-right"></span></Link></div>
                </div>
            </div>
        </div>

        {/* Website Maintenance */}
        <div className="featured-block col-lg-4 col-md-6 col-sm-12">
            <div className="inner-box wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                <div className="image-box">
                    <Link to="/services">
                        <img src="assets/images/images/main.png" alt="Website Maintenance" />
                    </Link>
                </div>
                <div className="lower-box">
                    <h3><Link to="/services">Website Maintenance</Link></h3>
                    <div className="text">
                        Keep your website secure, updated, fast, and running smoothly.
                    </div>
                    <div className="more-link"><Link to="/services"><span className="fa fa-arrow-right"></span></Link></div>
                </div>
            </div>
        </div>

        {/* Digital Marketing */}
        <div className="featured-block col-lg-4 col-md-6 col-sm-12">
            <div className="inner-box wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
                <div className="image-box">
                    <Link to="/services">
                        <img src="assets/images/images/1.png" alt="Digital Marketing" />
                    </Link>
                </div>
                <div className="lower-box">
                    <h3><Link to="/services">Digital Marketing</Link></h3>
                    <div className="text">
                        Grow your brand with targeted digital campaigns and online visibility strategies.
                    </div>
                    <div className="more-link"><Link to="/services"><span className="fa fa-arrow-right"></span></Link></div>
                </div>
            </div>
        </div>

    </div>
</div>



                </div>
            </section>

            {/* Separator */}
            <div className="theme-separator"></div>

        </about>
    );
};

export default About;
